var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixMediaSiteMediaV1Folder from '@wix/ambassador-media-site-media-v1-folder/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var State;
(function (State) {
    State["OK"] = "OK";
    State["DELETED"] = "DELETED";
})(State || (State = {}));
export var Namespace;
(function (Namespace) {
    Namespace["NO_NAMESPACE"] = "NO_NAMESPACE";
    Namespace["OTHERS"] = "OTHERS";
    /** ANY = 2; */
    Namespace["WIX_VIDEO"] = "WIX_VIDEO";
    /** _nsWixMusic */
    Namespace["WIX_MUSIC"] = "WIX_MUSIC";
    /** _nsArtStore */
    Namespace["ALBUMS_AND_ART_STORE"] = "ALBUMS_AND_ART_STORE";
    /** _nsDigitalProduct */
    Namespace["WIX_ECOM"] = "WIX_ECOM";
    /** _nsPhotoShareApp */
    Namespace["PHOTO_SHARE_APP"] = "PHOTO_SHARE_APP";
    /** _nsSharingApp, */
    Namespace["SHARING_APP"] = "SHARING_APP";
    /** engage */
    Namespace["CHAT"] = "CHAT";
    /** logobuilder */
    Namespace["LOGO_BUILDER"] = "LOGO_BUILDER";
    /** WixExposure */
    Namespace["ALBUMS_OLD"] = "ALBUMS_OLD";
    /** chat-mobile-uploads */
    Namespace["CHAT_MOBILE"] = "CHAT_MOBILE";
    /** _nsWixForms */
    Namespace["WIX_FORMS"] = "WIX_FORMS";
})(Namespace || (Namespace = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var RootFolder;
(function (RootFolder) {
    /** Root of all site media */
    RootFolder["MEDIA_ROOT"] = "MEDIA_ROOT";
    /** Root of the trash system folder */
    RootFolder["TRASH_ROOT"] = "TRASH_ROOT";
    /** Root of all visitor uploads */
    RootFolder["VISITOR_UPLOADS_ROOT"] = "VISITOR_UPLOADS_ROOT";
})(RootFolder || (RootFolder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _bulkDeleteFoldersRequest = {};
const _bulkDeleteFoldersResponse = {};
const _bulkRestoreFoldersFromTrashBinRequest = {};
const _bulkRestoreFoldersFromTrashBinResponse = {};
const _createFolderRequest = {};
const _createFolderResponse = {};
const _generateFolderDownloadUrlRequest = {};
const _generateFolderDownloadUrlResponse = {};
const _getFolderRequest = {};
const _getFolderResponse = {};
const _listDeletedFoldersRequest = {};
const _listDeletedFoldersResponse = {};
const _listFoldersRequest = {};
const _listFoldersResponse = {};
const _searchFoldersRequest = {};
const _searchFoldersResponse = {};
const _updateFolderRequest = {};
const _updateFolderResponse = {};
/**
 * Creates a new folder in the Media Manager.
 *
 * The `createFolder()` function returns a Promise that resolves to the created folder.
 *
 * Use the `parentFolderId` parameter to specify in which existing folder you want the new folder to be created.
 * If no folder is specified, the new folder is created in the `media-root` folder.
 * @param displayName - Folder name that appears in the Media Manager.
 * @public
 * @requiredField displayName
 * @param options - Options for specifying where to create a folder.
 * @adminMethod
 */
export function createFolder(displayName, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            displayName: '$[0]',
            parentFolderId: '$[1].parentFolderId',
            rawNamespace: '$[1].rawNamespace',
            namespace: '$[1].namespace',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createFolderRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createFolderResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['folder']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([displayName, options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1Folder.createFolder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'displayName',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Gets information from the specified folder in the Media Manager.
 *
 * The `getFolder()` function returns a Promise that resolves to information about the specified folder.
 * @param folderId - Folder ID.
 * @public
 * @requiredField folderId
 * @adminMethod
 * @returns Information about the folder.
 */
export function getFolder(folderId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { folderId: '$[0]' };
        const responseTransformation = '$.folder';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getFolderRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getFolderResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['folder']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([folderId]);
        const reqOpts = ambassadorWixMediaSiteMediaV1Folder.getFolder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'folderId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of folders in the Media Manager.
 *
 * The `listFolders()` function returns a Promise that resolves to information about the specified folders and cursor information.
 *
 * To retrieve a list of folders within a specific folder in the Media Manager, pass the specific folder's ID in the `parentFolderId` parameter. If no folder is specified, the function retrieves only the list of folders within the root folder of the Media Manager.
 *
 * To retrieve a list of (non-permanently) deleted folders, use the `listDeletedFolders()` function.
 * @public
 * @param options - Options to use when listing folders from the Media Manager.
 * @adminMethod
 */
export function listFolders(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            parentFolderId: '$[0].parentFolderId',
            sort: '$[0].sort',
            paging: '$[0].paging',
            rawNamespace: '$[0].rawNamespace',
            namespace: '$[0].namespace',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listFoldersRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listFoldersResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#folders']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1Folder.listFolders(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Searches the Media Manager and returns a list of folders that match the terms specified in the parameters.
 *
 * The `searchFolders()` function returns a Promise that resolves to information about the specified folders and cursor information.
 *
 * If no parameters are specified, the function returns all folders in the `MEDIA_ROOT` folder.
 * @public
 * @param options - Options specifying which folders to search.
 * @adminMethod
 */
export function searchFolders(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            rootFolder: '$[0].rootFolder',
            sort: '$[0].sort',
            paging: '$[0].paging',
            search: '$[0].search',
            rawNamespace: '$[0].rawNamespace',
            namespace: '$[0].namespace',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _searchFoldersRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _searchFoldersResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#folders']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1Folder.searchFolders(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a folder.
 *
 * The `updateFolder()` function returns a Promise that resolves to information about the updated folder.
 *
 * You can use the `parentFolderId` parameter to move a folder from its current parent folder to a different parent folder.
 * @param _id - Folder ID. Generated when a folder is created in the Media Manager.
 * @public
 * @requiredField _id
 * @requiredField folder
 * @param folder - Folder to update.
 * @adminMethod
 * @returns Information about the updated folder.
 */
export function updateFolder(_id, folder, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            folder: { '*': '$[1]', id: '$[0]' },
            fieldMask: '$[2].fieldMask',
        };
        const responseTransformation = '$.folder';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateFolderRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['folder']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateFolderResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['folder']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, folder, options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1Folder.updateFolder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'folder',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Generates a URL for downloading a compressed file containing a specific folder in the Media Manager.
 *
 * The `generateFolderDownloadUrl()` function returns a Promise that resolves to a download URL.
 *
 * The compressed file can contain sub-folders, and up to 1000 files.
 * @param folderId - Folder ID.
 * @public
 * @requiredField folderId
 * @adminMethod
 */
export function generateFolderDownloadUrl(folderId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { folderId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _generateFolderDownloadUrlRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _generateFolderDownloadUrlResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([folderId]);
        const reqOpts = ambassadorWixMediaSiteMediaV1Folder.generateFolderDownloadUrl(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'folderId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Temporarily deletes the specified folders from the Media Manager.
 *
 * The `bulkDeleteFolders()` function returns a Promise that resolves when the folders are deleted.
 *
 * The deleted folders are moved to the Media Manager's `TRASH_ROOT` folder (trash bin) unless permanently deleted. To permanently delete folders, pass the `permanent` parameter with the value `true`. Permanently deleting folders isn't reversible, so make sure that the files in these folders aren't being used in a site or in any other way as the files will no longer be accessible.
 *
 * >**Notes:**
 * > - When a folder is deleted, the files in that folder are deleted.
 * > - The specified folders can be from different parent folders.
 * > - Moving multiple folders at once is an asynchronous action, and may take time for the changes to appear in the Media Manager.
 * > - Attempting to delete folders that are already in the trash bin doesn't result in an error.
 * > - If your site contains files from a non-permanently deleted media folder, the files still appear on your site as the deleted folder is still in the Media Manager (in the trash bin).
 * > - You can use the `bulkRestoreFoldersFromTrashBin()` function to restore folders from the Media Manager's trash bin.
 * @param folderIds - IDs of the folders to move to the Media Manager's trash bin.
 * @public
 * @requiredField folderIds
 * @param options - Options to use when deleting folders.
 * @adminMethod
 */
export function bulkDeleteFolders(folderIds, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            folderIds: '$[0]',
            permanent: '$[1].permanent',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkDeleteFoldersRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkDeleteFoldersResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([folderIds, options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1Folder.bulkDeleteFolders(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'folderIds',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Restores the specified folders from the Media Manager's trash bin, and moves them to their original locations in the Media Manager.
 *
 *
 * The `bulkRestoreFoldersFromTrashBin()` function returns a Promise that resolves when the folders have been restored.
 * @param folderIds - IDs of the folders to restore from the Media Manager's trash bin.
 * @public
 * @requiredField folderIds
 * @adminMethod
 */
export function bulkRestoreFoldersFromTrashBin(folderIds) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { folderIds: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkRestoreFoldersFromTrashBinRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkRestoreFoldersFromTrashBinResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([folderIds]);
        const reqOpts = ambassadorWixMediaSiteMediaV1Folder.bulkRestoreFoldersFromTrashBin(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'folderIds',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of deleted folders from the trash bin.
 *
 * The `listDeletedFolders()` function returns a Promise that resolves to information about the specified deleted folders and cursor information.
 *
 * To retrieve a list of non-deleted folders, use the `listFolders()` function.
 * @public
 * @param options - Options to use when listing deleted folders from the trash bin.
 * @adminMethod
 */
export function listDeletedFolders(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            parentFolderId: '$[0].parentFolderId',
            sort: '$[0].sort',
            paging: '$[0].paging',
            rawNamespace: '$[0].rawNamespace',
            namespace: '$[0].namespace',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listDeletedFoldersRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listDeletedFoldersResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#folders']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1Folder.listDeletedFolders(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=media-site-media-v1-folder.universal.js.map